import React from 'react';
import { Button, Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createMarkup } from '../../utils/helper';
import NewLoading from '../../Components/Common/NewLoading';
import { Translate } from '../../localization';

const PromotionBanners = () => {
    const { promotionBanners, promotionBannersLoading } = useSelector((state) => state.general);

    return (
        <div className="odds-panel_promotion">
            {promotionBannersLoading ?
                <NewLoading customClass="min-height-loader" />
                : promotionBanners.length > 0 ? <div>
                    {promotionBanners.map((data) => {
                        return (
                            <div className="col-md-6 col-lg-4 mb-4" key={data?.id}>
                                <div className="promotion-card">
                                    <div className="promotion-img">
                                        <img src={data.vimage_urls} alt="promotion-banner" className="Promotion_banner" />
                                    </div>
                                    <div className="promotion-text">
                                        <h3>
                                            {' '}
                                            <Link to={`/${Translate.getLanguage()}/d/promotion/${data.slug}`}> {data.title} </Link>{' '}
                                        </h3>
                                        <p dangerouslySetInnerHTML={createMarkup(data?.content || '')} className="about-para" />
                                        <Link className="promotion-read-more" to={`/${Translate.getLanguage()}/d/promotion/${data.slug}`}>
                                            {' '}
                                            Read More{' '}
                                        </Link>
                                        {/* <p>{data.description}</p>
                                    <div className="promotion-btn-wrap">
                                        {isLoyalty && <Link to='/d/loyalty'> <Button className="find-more_btn btn-primary"><b>Read More</b></Button></Link>}
                                        {!isLoyalty && <Link to={`/d/promotion/${data.url}`}> <Button className="find-more_btn btn-primary"><b>Read More</b></Button></Link>}
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                    : <div className="nothing-found-casino text-white">No Promtions Are Available</div>
            }
        </div>
    );
};

export default PromotionBanners;
